import React from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import {
    getAddedCollaborators,
    getAutoComplete,
    removeTheLastAddedCollaborator,
    invalidShare,
    resetAddedCollaborators,
    autoCompleteLoading, autoCompleteEnteredValue, resetAutoComplete, rightToAdd,
} from '../../../../../../../../../actions/sharingDetailsActions';
import {API_ROOT, checkEmailFormat} from '../../../../../../../../utils/index';
import {
	hasDuplicatedEmail,
	isEmailValid,
	isEmpty,
	selectedCollaboratorIndex
} from '../../../../../../../../../actions/addCollaboratorActions';
import Avatar from "../../../../../../../../components/avatar";
import './index.css';

class AddCollaboratorsField extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			hasInputValueChanged: false,
		};

		this.removeCollaborator = this.removeCollaborator.bind(this);
		this.addCollaboratorChangeHandler = this.addCollaboratorChangeHandler.bind(this);
		this.keyDownHandler = this.keyDownHandler.bind(this);
		this.keyPressHandler = this.keyPressHandler.bind(this);
	}

	addCollaboratorChangeHandler(e){

		this.props.resetAutoComplete();

		if(this.props.selectedCollaboratorIndex !== -1){
			this.props.setSelectedCollaboratorIndex(-1);
		}

		if(this.props.isEmailValid === false){
			this.props.setIsEmailValid(true);
		}

		if(this.props.isEmpty){
			this.props.setIsEmpty(false);
		}

		if(this.props.hasDuplicatedEmail){
			this.props.setHasDuplicatedEmail(false);
		}

		this.props.autoCompleteEnteredValue(e.currentTarget.value);

		if(e.currentTarget.value.length > 1){
			this.props.autoCompleteLoading(true);
			this.props.getAutoComplete(e.currentTarget.value);
		}

	}

	removeCollaborator(e){

		/*
		* Catch the name without the "×"
		* */

		let collaboratorName = e.currentTarget.parentNode.textContent.substr(0, e.currentTarget.parentNode.textContent.length - 1);
		let collaboratorEmail = e.currentTarget.parentNode.dataset.email;

		let collaboratorsToKeep = [];
		let someInvalidCollaboratorToAdd = false;

		this.props.addedCollaborators.filter(user => {
			if(user.name){
				if (collaboratorName !== user.name) {
					collaboratorsToKeep = [...collaboratorsToKeep, user]
				}
			} else {
				if (collaboratorEmail !== user.email) {
					collaboratorsToKeep = [...collaboratorsToKeep, user]
				}
			}

			return collaboratorsToKeep;
		});

		collaboratorsToKeep.forEach(user => {
			if(user.invalid){
				someInvalidCollaboratorToAdd = true;
			}
		});

		if(someInvalidCollaboratorToAdd){
			this.props.setInvalidShare(true);
		} else {
			this.props.setInvalidShare(false);
		}

		this.props.resetAddedCollaborators();

		/*
		 * To avoid an empty array
		 * */

		if(collaboratorsToKeep.length >= 1){

			collaboratorsToKeep.forEach(item => {
				this.props.getAddedCollaborators(item);
			});

		} else {

			this.props.setRightToAdd('READ_ONLY');

		}

	}

	keyDownHandler(e){

		if(e.which === 38){


			/*
			*  If up arrow is pressed
			* */

			e.preventDefault();

			if(this.props.selectedCollaboratorIndex > 0) {

				this.props.setSelectedCollaboratorIndex(this.props.selectedCollaboratorIndex - 1);

			}

		} else if (e.which === 40){

			/*
			*  If down arrow is pressed
			* */

			e.preventDefault();

			if(this.props.selectedCollaboratorIndex < document.querySelectorAll(".js-result").length - 1){

				this.props.setSelectedCollaboratorIndex(this.props.selectedCollaboratorIndex + 1);
			}
		} else if (e.which === 8){
			if(this.props.addedCollaborators.length > 0 && document.querySelector('.badges-wrapper input').value === ""){
				this.props.removeTheLastAddedCollaborator();
			}
		} else {
			/* Nothing to do */
		}
	}

	keyPressHandler(e){

		/*
		*  If Enter key is pressed
		* */

		if (e.which === 13){

			let collaboratorsArray = [];
            let addCollaboratorsFieldValue = document.getElementById("addCollaboratorsField").value.trim().toLowerCase();

			if(e.currentTarget.value.indexOf(",") !== -1){
				let severalCollaboratorsToAdd = e.target.value.split(",");

				severalCollaboratorsToAdd.forEach((item, index) => {
					if(checkEmailFormat(item)){

						/*
						* Valid email addresses are put into function to retrieve information thanks to autocompletion data
						* */

						axios.get(API_ROOT + '/api/auto?key=' + item, {withCredentials: true}).then( response => {

							if(response.data.length > 0){
								if(this.props.selectOneLabelFromPopup){
									this.props.getAddedCollaborators({
										"groupId": this.props.selectOneLabelFromPopup.id,
										"id": response.data[0].id,
										"email": response.data[0].email,
										"permission": "READ_ONLY",
										"type": response.data[0].type,
										"addToContact": false,
										"toRemove": false,
									});
								} else {
									this.props.getAddedCollaborators({
										"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
										"id": response.data[0].id,
										"email": response.data[0].email,
										"permission": "READ_ONLY",
										"type": response.data[0].type,
										"addToContact": false,
										"toRemove": false,
									});
								}
							} else {
								if(this.props.selectOneLabelFromPopup){
									this.props.getAddedCollaborators({
										"groupId": this.props.selectOneLabelFromPopup.id,
										"id": item,
										"email": item,
										"permission": this.props.rightToAdd,
										"type": "user",
										"addToContact": false,
										"toRemove": false,
									});
								} else {
									this.props.getAddedCollaborators({
										"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
										"id": item,
										"email": item,
										"permission": this.props.rightToAdd,
										"type": "user",
										"addToContact": false,
										"toRemove": false,
									});
								}
							}
						});

					} else {

						if(this.props.selectOneLabelFromPopup){
							this.props.getAddedCollaborators({
								"groupId": this.props.selectOneLabelFromPopup.id,
								"id": index,
								"email": item,
								"permission": this.props.rightToAdd,
								"type": "user",
								"addToContact": false,
								"toRemove": false,
								"invalid": true
							});
						} else {
							this.props.getAddedCollaborators({
								"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
								"id": index,
								"email": item,
								"permission": this.props.rightToAdd,
								"type": "user",
								"addToContact": false,
								"toRemove": false,
								"invalid": true
							});
						}


						this.props.setInvalidShare(true);
					}

				});

				document.getElementById("addCollaboratorsField").value = "";

			} else if (this.props.autoComplete.length > 0){

                if (addCollaboratorsFieldValue !== "") {
                    if(this.props.selectedCollaboratorIndex !== -1 || checkEmailFormat(addCollaboratorsFieldValue)){

                        this.props.autoComplete.forEach(item => {

                            if(document.querySelectorAll(".js-result")[this.props.selectedCollaboratorIndex] !== undefined){

                                if (item.id === document.querySelectorAll(".js-result")[this.props.selectedCollaboratorIndex].getAttribute("id")){
									if(this.props.selectOneLabelFromPopup){
										collaboratorsArray = collaboratorsArray.concat({
											"groupId": this.props.selectOneLabelFromPopup.id,
											"id": item.id ? item.id : item.email,
											"name": item.name,
											"email": item.email,
											"permission": this.props.rightToAdd,
											"type": item.type,
											"addToContact": false,
											"toRemove": false
										});
									} else {
										collaboratorsArray = collaboratorsArray.concat({
											"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
											"id": item.id ? item.id : item.email,
											"name": item.name,
											"email": item.email,
											"permission": this.props.rightToAdd,
											"type": item.type,
											"addToContact": false,
											"toRemove": false
										});
									}
                                }
                            } else {

                            	let found = false;

                                if (item.email === addCollaboratorsFieldValue){
									if(this.props.selectOneLabelFromPopup){
										collaboratorsArray = collaboratorsArray.concat({
											"groupId": this.props.selectOneLabelFromPopup.id,
											"id": item.id ? item.id : item.email,
											"name": item.name,
											"email": item.email,
											"permission": this.props.rightToAdd,
											"type": item.type,
											"addToContact": false,
											"toRemove": false
										});
									} else {
										collaboratorsArray = collaboratorsArray.concat({
											"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
											"id": item.id ? item.id : item.email,
											"name": item.name,
											"email": item.email,
											"permission": this.props.rightToAdd,
											"type": item.type,
											"addToContact": false,
											"toRemove": false
										});
									}


                                    found = true;
                                }

                                if(!found){
									if(this.props.selectOneLabelFromPopup){
										collaboratorsArray = collaboratorsArray.concat({
											"groupId": this.props.selectOneLabelFromPopup.id,
											"id": addCollaboratorsFieldValue,
											"name": "",
											"email": addCollaboratorsFieldValue,
											"permission": this.props.rightToAdd,
											"type": "user",
											"addToContact": false,
											"toRemove": false
										});
									} else {
										collaboratorsArray = collaboratorsArray.concat({
											"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
											"id": addCollaboratorsFieldValue,
											"name": "",
											"email": addCollaboratorsFieldValue,
											"permission": this.props.rightToAdd,
											"type": "user",
											"addToContact": false,
											"toRemove": false
										});
									}

								}
                            }
                        });

                        this.props.getAddedCollaborators(...collaboratorsArray);
                        this.props.autoCompleteEnteredValue("");
                        document.getElementById("addCollaboratorsField").value = "";
                        this.props.setIsEmailValid(true);

                    } else {

                        /*this.setState({
                            isEmailValid: false,
                        });*/

                        if(this.props.isEmailValid){
                            this.props.setIsEmailValid(false);
                        }

                    }
				} else {
                	this.props.launchShare(e.currentTarget.dataset);
				}

			} else if (addCollaboratorsFieldValue !== "") {
				if(checkEmailFormat(addCollaboratorsFieldValue)){

					/*
					* A new external user
					* */

					if(this.props.selectOneLabelFromPopup){
						collaboratorsArray = collaboratorsArray.concat({
							"groupId": this.props.selectOneLabelFromPopup.id,
							"id": addCollaboratorsFieldValue,
							"name": "",
							"email": addCollaboratorsFieldValue,
							"permission": this.props.rightToAdd,
							"type": "user",
							"addToContact": false,
							"toRemove": false
						});
					} else {
						collaboratorsArray = collaboratorsArray.concat({
							"groupId": this.props.selectedContactsGroup.type === "system" ? 6 : this.props.selectedContactsGroup.id,
							"id": addCollaboratorsFieldValue,
							"name": "",
							"email": addCollaboratorsFieldValue,
							"permission": this.props.rightToAdd,
							"type": "user",
							"addToContact": false,
							"toRemove": false
						});
					}


					this.props.getAddedCollaborators(...collaboratorsArray);
					document.getElementById("addCollaboratorsField").value = "";

				} else {
					this.props.setIsEmailValid(false)
				}

			} else {
				if(this.props.addedCollaborators.length > 0){
					this.props.launchShare(e.currentTarget.dataset);
				} else {
                    if(this.props.isEmpty === false){
                        this.props.setIsEmpty(true);
                    }
				}


			}

		} else {
			this.setState({
				hasInputValueChanged: true
			})
		}
	}

	render() {
        return (
            <div className="badges-wrapper d-flex flex-wrap w-100 align-items-center">
                {
                    this.props.addedCollaborators.length > 0 ?
                        this.props.addedCollaborators.map( (user, index) => {
                            if(user.id || user.email){
                                return (
                                    <div key={index} data-email={user.email} className={`badge${user.invalid ? ' error' : ''}`}>
                                        <Avatar size={18} src={`${API_ROOT}/account/avatar/${user.id}`} />
                                        {user.name ? user.name : user.email}
                                        <div className="close-btn" onClick={this.removeCollaborator}>×</div>
                                    </div>
                                )
                            } else {
                                return (
                                    <div key={user} data-email={user} className={`badge${user.invalid ? ' error' : ''}`}>
                                        {user}
                                        <div className="close-btn" onClick={this.removeCollaborator}>×</div>
                                    </div>
                                )
                            }
                        })
                    :
                        null
                }
                <input
					disabled={this.props.isSharing || (this.props.isUserListAddCollaboratorsPopupShown && !this.props.selectOneLabelFromPopup)}
					autoComplete="off"
	                type="text"
	                onChange={this.addCollaboratorChangeHandler}
	                onKeyDown={this.keyDownHandler}
	                onKeyPress={this.keyPressHandler}
	                className="form-control border-0 h-100 p-0 ml-1"
	                id="addCollaboratorsField"
                    data-contact-id={this.props.sharingDetailsPopup[2] ? this.props.sharingDetailsPopup[2] : null}
                    data-contact-name={this.props.sharingDetailsPopup[3] ? this.props.sharingDetailsPopup[3] : null}
                    data-contact-type={this.props.sharingDetailsPopup[4] ? this.props.sharingDetailsPopup[4] : null}
					placeholder={this.props.addedCollaborators.length === 0 ? this.props.t("popupSharingAddPeople") : ''}
                />
            </div>
        )
	}
}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
		selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
		addedCollaborators: state.sharingDetailsReducer.getAddedCollaborators,
        sharingDetailsPopup : state.sharingDetailsReducer.getSharingDetailsPopup,
		autoComplete: state.sharingDetailsReducer.getAutoComplete,
        rightToAdd: state.sharingDetailsReducer.rightToAdd,
		invalidShare: state.sharingDetailsReducer.invalidShare,
		isEmpty: state.addCollaboratorDetailsReducer.isEmpty,
		isEmailValid: state.addCollaboratorDetailsReducer.isEmailValid,
		hasDuplicatedEmail: state.addCollaboratorDetailsReducer.hasDuplicatedEmail,
		selectedCollaboratorIndex: state.addCollaboratorDetailsReducer.selectedCollaboratorIndex,
		isUserListAddCollaboratorsPopupShown: state.popupReducer.isUserListAddCollaboratorsPopupShown,
		selectOneLabelFromPopup: state.contactsGroupItemReducer.selectOneLabelFromPopup,
		isSharing : state.sharingDetailsReducer.isSharing
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		autoCompleteLoading : (boolean) => {
			dispatch(autoCompleteLoading(boolean))
		},
		getAutoComplete : (string) => {
			dispatch(getAutoComplete(string))
		},
		resetAutoComplete : () => {
			dispatch(resetAutoComplete())
		},
		autoCompleteEnteredValue : (string) => {
			dispatch(autoCompleteEnteredValue(string))
		},
		getAddedCollaborators : (array) => {
			dispatch(getAddedCollaborators(array))
		},
        setRightToAdd : (array) => {
            dispatch(rightToAdd(array))
        },
		resetAddedCollaborators: () => {
			dispatch(resetAddedCollaborators())
		},
		setInvalidShare : (boolean) => {
			dispatch(invalidShare(boolean))
		},
		setIsEmpty : (boolean) => {
			dispatch(isEmpty(boolean))
		},
		setIsEmailValid : (boolean) => {
			dispatch(isEmailValid(boolean))
		},
		setHasDuplicatedEmail : (boolean) => {
			dispatch(hasDuplicatedEmail(boolean))
		},
		setSelectedCollaboratorIndex : (int) => {
			dispatch(selectedCollaboratorIndex(int))
		},
		removeTheLastAddedCollaborator : () => {
			dispatch(removeTheLastAddedCollaborator())
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddCollaboratorsField));
